import { Cart, ItemBody } from '@adapters/bigcommerce/types/cart';
import findifyAnalyticsUpdateCart from '@adapters/findify/operations/analytics/updateCart';
import klaviyoAddToCart from '@adapters/klaviyo/operations/analytics/addToCart';
import { RRTrackAddToCart } from '@components/global/Recommendations/Loader';
import { trackCartViewEvent } from '@utils/gtm/ga4';
import { GA4_EVENT_NAMES } from '@utils/gtm/ga4';

const { MINI_CART, VIEW_CART } = GA4_EVENT_NAMES;

export const triggerAnalytics = ({
  data,
  item,
  categories,
  categoryId,
}: {
  data: Cart;
  item?: ItemBody;
  categories?: string[];
  categoryId?: string;
}) => {
  trackCartViewEvent({
    eventName: VIEW_CART,
    cart: data,
    extraAttributes: { cart_type: MINI_CART },
  });
  findifyAnalyticsUpdateCart({ data });
  klaviyoAddToCart({ data, item, categories });
  if (item?.productId && item?.variantId) {
    const selectedItem = data?.cartData?.line_items.physical_items.find(
      (x) => x.product_id === item.productId && x.variant_id === item.variantId
    );
    RRTrackAddToCart({
      itemId: selectedItem?.code ?? '',
      skuId: selectedItem?.sku.toString() ?? '',
      categoryId,
    });
  }
};
